import { TextField } from '@mui/material';

const AppInput = ({ sx, ...props }) => {
  return (
    <TextField
      fullWidth
      sx={{
        borderRadius: '8px',
        '& .MuiInputBase-root': { borderRadius: '8px', backgroundColor: 'white' },
        '& .MuiInputBase-input': {
          fontSize: '1.25rem',
          py: 0,
          px: 1,
          height: 40,
          color: '#004559',
        },
        '& .MuiInputBase-input::placeholder': { fontSize: '1.25rem' },
        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '8px',
          border: '2px solid #004559',
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default AppInput;
